const FILTER_LABELS = {
  gift_card_product_id: 'Product',
  scope: 'Where It Works',
  channel: 'Channel',
  venue_ownership_id: 'Venue',
  kind: 'Entry Type',
};

export const buildGiftCardFilterGroups = (filterOptions = {}, filterIds = []) => filterIds
  .filter((id) => (filterOptions[id] || []).length > 0)
  .map((id) => ({
    id,
    label: FILTER_LABELS[id],
    filters: [
      {
        id,
        label: FILTER_LABELS[id],
        type: 'checkbox',
        options: filterOptions[id].map((option) => ({ value: String(option.value), label: option.label })),
      },
    ],
  }));

export const buildGiftCardDetailApiFilters = (activeFilters) => Object.keys(FILTER_LABELS).reduce((params, id) => {
  if (activeFilters[id] && activeFilters[id].length > 0) {
    return { ...params, [id]: activeFilters[id] };
  }
  return params;
}, {});
